import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, Checkbox, SelectTag } from '../../../../../../components';
import { Button, Container, Dialog, IconButton, Paper, Stack, Typography ,Box} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { request, toast } from '../../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../../components';
import { WAREHOUSE_TYPE_PHARMACY } from '../../../../../../constants/dropdown';

const TABLE_COLUMNS = [
    {
        header: 'Warehouse Name',
        accessor: (row) => {
            const status = row.status;
            return (
                <span
                    style={{
                        color: status === 'inactive' ? 'red' : 'black',
                    }}
                >
                    {`${row.warehouse_name}`}
                </span>
            );
        },
    },
    {
        header: 'Warehouse Type',
        accessor: 'warehouse_type'
    },
    {
        header: 'Status',
        accessor: 'status',
        sx: { textTransform: 'uppercase' }
    },
    {
        header: 'Created At',
        accessor: 'createdAt'
    }
];

const initialWareHouseMasterDataObj = {
    data: [],
    loading: false
};

export const Warehouse = () => {
    const [openQueryDialog, setOpenQueryDialog] = useState(false);
    const [warehouseMasterDataObj, setwarehouseMasterDataObj] = useState(initialWareHouseMasterDataObj);
    const [loading, setLoading] = useState(false);
    const [currentAction, setCurrentAction] = useState();
    const [selectedRecord, setSelectedRecord] = useState();
    const { pathname } = useLocation();
    const lastPathSegment = pathname.split('/').pop();

    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                warehouse_name: Yup.string().required('Ware House Name  is required'),
                warehouse_type: Yup.string().required('Ware House Type  is required')
            })
        ),
        mode: 'all'
    });
    const { handleSubmit, setValue, reset } = methods;

    useEffect(() => {
        if (selectedRecord) {
            setValue('warehouse_name', selectedRecord.warehouse_name);
            setValue('warehouse_type', selectedRecord.warehouse_type);
            setValue('default', selectedRecord.status === 'default');
        } else {
            reset();
        }
    }, [setValue, reset, selectedRecord]);

    const formSubmit = async (formValues) => {
        setLoading(true);
        let editFlag = false;
        if (selectedRecord && currentAction === 'edit') {
            editFlag = true;
        }
        const response = await request(editFlag ? '/warehouse-update' : '/warehouse-create', {
            method: editFlag ? 'PUT' : 'POST',
            params: editFlag ? selectedRecord._id : null,
            body: {
                warehouse_name: formValues.warehouse_name,
                warehouse_type: formValues.warehouse_type,
                status: formValues.default ? 'default' : 'active'
            }
        });
        if (response?.success) {
            toast(`Successfully ${editFlag ? 'edited' : 'created'} Ware House master`, { variant: 'success' });
            setSelectedRecord(response.data);
            setCurrentAction();
        } else {
            toast(`Failed to ${editFlag ? 'edit' : 'create'} Ware House master`, { variant: 'error' });
        }
        setLoading(false);
    };

    const handleCancelRecord = async () => {
        setLoading(true);
        const response = await request('/warehouse-cancel', {
            method: 'DELETE',
            params: selectedRecord._id
        });
        if (response?.success) {
            toast('Successfully cancelled Ware House master', { variant: 'success' });
            setSelectedRecord();
        } else {
            toast('Failed to cancel Ware house Master', { variant: 'error' });
        }
        setLoading(false);
    };

    const handleDeleteRecord = async () => {
        setLoading(true);
        const response = await request('/warehouse-delete', {
            method: 'DELETE',
            params: selectedRecord._id
        });
        if (response?.success) {
            toast('Successfully deleted Ware House master', { variant: 'success' });
            setSelectedRecord();
        } else {
            toast('Failed to delete Ware house Master', { variant: 'error' });
        }
        setLoading(false);
    };

    const handleQueryWindow = async () => {
        setOpenQueryDialog(true);
        setwarehouseMasterDataObj({ loading: true });
        const response = await request('/warehouse-list', {
            method: 'GET'
        });
        if (response.success) {
            const filteredData = response.data.filter(item =>
                item.status === 'active' || item.status === 'inactive' || item.status === 'default'
            );
            setwarehouseMasterDataObj({ loading: false, data: filteredData });
        } else {
            toast('Failed to load Ware House master list', { variant: 'error' });
            setwarehouseMasterDataObj({ loading: false });
        }
    };

    return (
        <>
            <Paper sx={{
                p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
                width: '100%',
                height: 'auto'
            }}>
                <Container
                    sx={{
                        mt: 1,
                        border: '0px solid',
                        borderColor: 'grey.300',
                        borderRadius: 1,
                        width: '100%',
                        maxWidth: 'none',
                        minWidth: "100%",
                        boxSizing: 'border-box',
                    }}
                >
                    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
                        <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{
                                mb: 1,
                                borderBottom: '0px solid',
                                borderColor: 'grey.300'
                            }}
                        >
                            <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                                Warehouse Management
                            </Typography>
                            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                                <CustomButtonn
                                    id={`${lastPathSegment}Write`}
                                    variant="contained"
                                    disabled={['edit', 'new'].includes(currentAction)}
                                    onClick={() => {
                                        setSelectedRecord();
                                        setCurrentAction('new');
                                        reset();
                                    }}
                                >
                                    New
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Update`}
                                    variant="contained"
                                    disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                                    onClick={() => setCurrentAction('edit')}
                                >
                                    Edit
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Submit"}
                                    type="submit"
                                    variant="contained"
                                    disabled={!['edit', 'new'].includes(currentAction) || loading}
                                >
                                    Save
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Cancel"}
                                    variant="contained"
                                    disabled={['edit', 'new'].includes(currentAction) || loading}
                                    onClick={() => {
                                        setCurrentAction();
                                        handleCancelRecord()
                                    }}
                                >
                                    Cancel
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`isSuperAdmin`}
                                    variant="contained"
                                    disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                                    onClick={handleDeleteRecord}
                                >
                                    Delete
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Read`}
                                    variant="contained"
                                    onClick={handleQueryWindow}
                                    disabled={['new', 'edit'].includes(currentAction)}
                                >
                                    Query
                                </CustomButtonn>
                                <CustomButtonn id={`${lastPathSegment}Print`} variant="contained" disabled={!selectedRecord || currentAction}>
                                    Print
                                </CustomButtonn>
                                <CustomButtonn id={"Exit"} variant="contained"
                                    onClick={() => {
                                        setCurrentAction('');
                                    }}
                                >Exit</CustomButtonn>
                            </Stack>
                        </Stack>
                        <Stack spacing={0.5}>
                        <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '60%',boxShadow: '0px 2px 10px #0099ff'  }}>
                            <Stack direction="row" spacing={2} alignItems="center">
                                <Typography sx={{ flex: 0.15, fontSize: '1.4rem', fontWeight: 700 }}>Warehouse Type</Typography>
                                <SelectTag
                                    name="warehouse_type"
                                    formControlSX={{ flex: 0.8, border: currentAction ? "0.5px solid red" : "" }}
                                    placeholder="Warehouse Type"
                                    fullWidth
                                    disabled={!['new', 'edit'].includes(currentAction)}
                                    menus={WAREHOUSE_TYPE_PHARMACY}
                                />
                            </Stack>
                            <Stack direction="row" spacing={2} alignItems="center">
                                <Typography sx={{ flex: 0.168, fontSize: '1.4rem', fontWeight: 700 }}>Warehouse Name</Typography>
                                <TextField
                                    name="warehouse_name"
                                    sx={{ flex: 0.8, border: currentAction ? "0.5px solid red" : "" }}
                                    placeholder="Warehouse Name"
                                    fullWidth
                                    disabled={!['new', 'edit'].includes(currentAction)}
                                />
                                <Stack direction="row" spacing={2} alignItems="center">
                                    <Typography sx={{ flex: 0.25, fontSize: '1.4rem', fontWeight: 700 }}>Default</Typography>
                                    <Checkbox disabled={!['new', 'edit'].includes(currentAction)} name="default" fontSize={18} />
                                </Stack>
                            </Stack>
                            </Box>
                        </Stack>
                    </FormProvider>
                </Container>
            </Paper >
            <Dialog
                open={openQueryDialog}
                onClose={() => setOpenQueryDialog(false)}
                PaperProps={{ sx: { width: '80%', p: 2 } }}
                maxWidth="xl"
                scroll="body"
            >
                <Stack
                    padding={0}
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                    borderBottom="1px solid"
                    borderColor="grey.300"
                >
                    <Typography variant="h4" fontWeight="bold">
                        Warehouse Master Query Window
                    </Typography>
                    <IconButton onClick={() => setOpenQueryDialog(false)}>
                        <CloseIcon color="error" fontSize="large" />
                    </IconButton>
                </Stack>
                <Table
                    sx={{ mt: 0.5 }}
                    columns={TABLE_COLUMNS}
                    data={warehouseMasterDataObj.data || []}
                    loading={warehouseMasterDataObj.loading}
                    onRowClick={(row) => {
                        setOpenQueryDialog(false);
                        setSelectedRecord(row);
                    }}
                />
            </Dialog>
        </>
    );
};
